import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Card, Form, Row, Col, Button, Spinner, Table } from "react-bootstrap";
import {
  geteventregistrationById
} from "../store/slices/userSlice";
import { useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { saveeventpackagesbulk } from "../services/dbService";

function Vieweventsregistration() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("id") || "";

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: 0, // This might be used for an existing registration, or set to 0 for new
    event: "", // Will be eventId
    phonenumber: "", // Registrant's phone number
    email: "", // Registrant's email (from authEmail)
    amount: 0, // Total calculated amount
    packages: [], // Array of selected packages
    members: [], // Array of guest/member details
    status: "1", // Default status
  });

  // New state: list of packages
  const [packages, setPackages] = useState([]);
  // packages: Array<{ name: string, rate: string, member: "yes"|"no" }>

  // Fetch existing event + packages (if editing)
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (eventId) {
          await fetchDetails(eventId);
        }
      } catch (error) {
        console.error("Error fetching event details:", error);
        // Optionally show a user-friendly message here
        // errorMessage("Failed to load event details.");
      }
    };
  
    fetchData();
  }, [eventId]);
  

  const fetchDetails = async (id) => {
    setLoading(true);
    try {
      const response = await geteventregistrationById(id);
      if (response?.status === 200 && response.data) {
        let eventData = response?.data;
        try {
          eventData.packages = JSON.parse(eventData.packages);
        } catch {
          eventData.packages = [];
        }

        try {
          eventData.members = JSON.parse(eventData.members);
        } catch {
          eventData.members = [];
        }

        // const data = response.data;
        // Assume response.data has all event fields and maybe .packages
        setFormData((prev) => ({
          ...prev,
          ...eventData,
        }));

        // If backend sent existing packages, hydrate state

      } else {
        Swal.fire("Error", "Error fetching event details!", "error");
      }

    } catch (error) {
      console.error("Error fetching event data:", error);
      Swal.fire("Error", "Error fetching event data!", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle changes in main form fields
  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    } catch (error) {
      console.error("Error in handleChange:", error);
      // Optionally show a user-friendly message
      // errorMessage("Something went wrong while updating the form.");
    }
  };
  





  return (
    <div>
      <Navbar />
      <Sidebar />
      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Card className="w-100">
                    <Card.Header style={{ background: "#f06969", height: "30px" }}>
                      <h6 className="fw-semibold" style={{ color: "white" }}>Event Registration Details</h6>
                    </Card.Header>
                    <Card.Body>

                      {/* ────────── Event Master Fields ────────── */}
                      <Row>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="id"
                              value={formData.id}
                              onChange={handleChange}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              value={formData.email}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="phonenumber"
                              value={formData.phonenumber}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Paypal Order Id</Form.Label>
                            <Form.Control
                              type="text"
                              name="orderid"
                              value={formData.orderid}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Paypal Trasaction Id</Form.Label>
                            <Form.Control
                              type="text"
                              name="orderid"
                              value={formData.transactionid}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Tracking Id</Form.Label>
                            <Form.Control
                              type="text"
                              name="orderid"
                              value={formData.trackingid}
                              readOnly
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label>Payment Status</Form.Label>
                            <Form.Control
                              type="text"
                              name="paymentstatus"
                              value={formData.paymentstatus}
                              readOnly
                            />
                          </Form.Group>
                        </Col>

                      </Row>


                      {/* ────────── Event Packages Table ────────── */}
                      <Card className="mt-4">
                        <Card.Header style={{ background: "#f06969", height: "30px" }}>
                          <h6 className="mb-0" style={{ color: "white" }}>Packages Selected</h6>
                        </Card.Header>
                        <Card.Body>
                          <Table bordered hover responsive>
                            <thead>
                              <tr>
                                <th style={{ width: "5%", background: "#f06969" }}>#</th>
                                <th style={{ width: "20%", background: "#f06969" }}>Start Date</th>
                                <th style={{ width: "20%", background: "#f06969" }}>End Date</th>
                                <th style={{ width: "40%", background: "#f06969" }}>Package</th>
                                <th style={{ width: "20%", background: "#f06969" }}>Adult</th>
                                <th style={{ width: "20%", background: "#f06969" }}>Kids</th>
                                <th style={{ width: "20%", background: "#f06969" }}>Rate</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.packages.map((pkg, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>{pkg.startdate}</td>
                                  <td>{pkg.enddate}</td>
                                  <td>{pkg.name}</td>
                                  <td>{pkg.adults}</td>
                                  <td>{pkg.kids}</td>
                                  <td>{pkg.rate}</td>
                                </tr>
                              ))}

                              {formData.packages.length === 0 ? (
                                <tr>
                                  <td colSpan={7} className="text-center">
                                    No packages added.
                                  </td>
                                </tr>
                              ) : (
                                <tr style={{ fontWeight: "bold", background: "#fbe6e6" }}>
                                  <td colSpan={4} className="text-end">
                                    Total:
                                  </td>
                                  <td>
                                    {formData.packages.reduce((sum, pkg) => sum + Number(pkg.adults || 0), 0)}
                                  </td>
                                  <td>
                                    {formData.packages.reduce((sum, pkg) => sum + Number(pkg.kids || 0), 0)}
                                  </td>
                                  <td>
                                    {formData.packages.reduce((sum, pkg) => sum + Number(pkg.rate || 0), 0)}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>




                        </Card.Body>
                      </Card>


                      {/* <Card className="mt-4">
                         
                          <Card.Header style={{background:"#f06969",height:"30px"}}>
                            <h6 className="mb-0" style={{color:"white"}}>Members</h6>
                          </Card.Header>
                          <Card.Body>
                           

                            <Table bordered hover responsive>
                              <thead>
                                <tr>
                                  <th style={{ width: "5%",background:"#f06969" }}>#</th>
                                  <th style={{ width: "20%",background:"#f06969" }}>Name</th>
                                  <th style={{ width: "20%",background:"#f06969" }}>Type</th>
                                  <th style={{ width: "10%",background:"#f06969" }}>Email</th>
                                  <th style={{ width: "10%" ,background:"#f06969"}}>Phone Number</th>
                                  <th style={{ width: "20%",background:"#f06969" }}>Package</th>
                                  <th style={{ width: "10%",background:"#f06969" }}>Rate</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.members.map((pkg, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{pkg.name}</td>
                                    <td>{pkg.type}</td>
                                    <td>{pkg.email}</td>
                                    <td>{pkg.phonenumber}</td>
                                    <td>{pkg.packageName}</td>
                                    <td>{pkg.packageRate}</td>
                                    
                                   
                                  </tr>
                                ))}

                                {formData.members.length === 0 && (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No memebrs added .
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>

                          </Card.Body>
                        </Card> */}

                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vieweventsregistration;
